import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import api from '../api/axios';
import { useTranslation } from 'react-i18next';

const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  // States: 'loading', 'success', 'error'
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    const confirmToken = async () => {
      try {
        // Hits your backend: router.get('/verify-email/:token', verifyEmail)
        await api.get(`/auth/verify-email/${token}`);
        setStatus('success');
        
        // Optional: Auto-redirect after 3 seconds
        setTimeout(() => {
          navigate('/login');
        }, 3500);
      } catch (err) {
        console.error("Verification error:", err);
        setStatus('error');
      }
    };

    if (token) {
      confirmToken();
    }
  }, [token, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full text-center p-8 bg-white shadow-lg rounded-xl">
        
        {status === 'loading' && (
          <div className="space-y-4">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
            <p className="text-gray-600 font-medium">
              {t('auth.verify.loading', 'Verifying your account...')}
            </p>
          </div>
        )}

        {status === 'success' && (
          <div className="space-y-4">
            <div className="text-green-500 text-5xl">✓</div>
            <h2 className="text-2xl font-bold text-gray-900">
              {t('auth.verify.success_title', 'Email Verified!')}
            </h2>
            <p className="text-gray-600">
              {t('auth.verify.success_msg', 'Your account is now active. Redirecting you to login...')}
            </p>
            <Link to="/login" className="inline-block mt-4 text-blue-600 font-semibold hover:underline">
              {t('nav.login', 'Login Now')}
            </Link>
          </div>
        )}

        {status === 'error' && (
          <div className="space-y-4">
            <div className="text-red-500 text-5xl">✕</div>
            <h2 className="text-2xl font-bold text-gray-900">
              {t('auth.verify.error_title', 'Verification Failed')}
            </h2>
            <p className="text-gray-600">
              {t('auth.verify.error_msg', 'The link is invalid or has expired.')}
            </p>
            <Link to="/register" className="inline-block mt-4 text-blue-600 font-semibold hover:underline">
              {t('nav.register', 'Try Registering Again')}
            </Link>
          </div>
        )}

      </div>
    </div>
  );
};

export default VerifyEmail;
